import firebase from 'firebase';
import Rebase from 're-base';

const firebaseConfig = { // DEV
  apiKey: 'AIzaSyAymjwYtMwlIssZ2I2HcxmrkdF5Ko4lL00',
  authDomain: 'vigiern-49.firebaseapp.com',
  databaseURL: 'https://vigiern-49.firebaseio.com',
  projectId: 'vigiern-49',
  storageBucket: 'vigiern-49.appspot.com',
  messagingSenderId: '268656067337',
  devEnvironment: true,
};
//
export const cloudFunctionsURL = 'https://us-central1-vigiern-49.cloudfunctions.net/api';
// const firebaseConfig = { // PROD
//   apiKey: 'AIzaSyAALthcBmAG4Aup3iYc1wV1x8Cr8aNdSLI',
//   authDomain: 'vigipro-f4299.firebaseapp.com',
//   databaseURL: 'https://vigipro-f4299.firebaseio.com',
//   projectId: 'vigipro-f4299',
//   storageBucket: 'vigipro-f4299.appspot.com',
//   messagingSenderId: '117574064982',
// };
// export const cloudFunctionsURL = 'https://us-central1-vigipro-f4299.cloudfunctions.net/api';

// const mapsApiKey = 'AIzaSyAAH1Ml2UK1l0ThMfz56Ed6FbEnhW4YzJU'; // DEV
// var mapsApiKey = ''; // PROD

const app = firebase.initializeApp(firebaseConfig);

export const ref = firebase.database().ref();
export const firebaseAuth = firebase.auth;
export const firebaseDb = firebase.database;
export const firebaseStorage = firebase.storage();
export const base = Rebase.createClass(app.database());
export const isDemo = !!firebaseConfig.devEnvironment;
export const GEO_CONSTANTS = {
  urls: {
    search: 'https://nominatim.openstreetmap.org/search',
    reverseGeocode: 'https://nominatim.openstreetmap.org/reverse',
  },
  initialPosAndZoom: {
    lat: 47.465824,
    lng: -0.546131,
    zoom: 11,
  },
  ggdCounty: 'Maine-et-Loire',
  country: 'France',
};
export const REGEX_PATTERNS = {
  // eslint-disable-next-line no-useless-escape
  email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
  phone: /^(\+?[0-9 ]+)$/,
  // eslint-disable-next-line no-useless-escape
  url: /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/,
  technicalId: /^([a-z0-9_-]*)$/,
};



// WEBPACK FOOTER //
// ./src/config/constants.js